import React, { FC, useRef, useState } from 'react';
import { dropZone, dropZoneActive, hint } from 'tools/toolStyles';

interface Props {
  accept: string;
  multiple?: boolean;
  label?: string;
  hintText?: string;
  onFiles: (files: any[]) => void;
}

const FileDropZone: FC<Props> = ({
  accept,
  multiple = false,
  label = 'Kéo thả file vào đây hoặc bấm để chọn',
  hintText,
  onFiles,
}) => {
  const inputRef = useRef<any>(null);
  const [active, setActive] = useState(false);
  const dragDepth = useRef(0);

  const emit = (list: any) => {
    if (!list || !list.length) return;
    const arr: any[] = [];
    for (let i = 0; i < list.length; i++) arr.push(list[i]);
    if (!multiple && arr.length > 1) {
      onFiles([arr[0]]);
    } else {
      onFiles(arr);
    }
  };

  const onDragEnter = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    dragDepth.current += 1;
    setActive(true);
  };

  const onDragLeave = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    dragDepth.current -= 1;
    if (dragDepth.current <= 0) {
      dragDepth.current = 0;
      setActive(false);
    }
  };

  const onDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    dragDepth.current = 0;
    setActive(false);
    const dt = e.dataTransfer;
    if (dt && dt.files) emit(dt.files);
  };

  const onClick = () => {
    if (inputRef.current) inputRef.current.click();
  };

  const onChange = (e: any) => {
    emit(e.target && e.target.files);
    // allow re-selecting same file
    if (e.target) e.target.value = '';
  };

  const onKey = (e: any) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div>
      <div
        role="button"
        tabIndex={0}
        style={active ? dropZoneActive : dropZone}
        onClick={onClick}
        onKeyDown={onKey}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDragOver={onDragOver}
        onDrop={onDrop}
        aria-label={label}
      >
        <div style={{ fontWeight: 700, fontSize: 14, color: '#37474f', marginBottom: 4 }}>{label}</div>
        {hintText ? <div style={{ ...hint, margin: 0, fontSize: 12 }}>{hintText}</div> : null}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={onChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default FileDropZone;
